import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import { LocalStorage } from 'quasar'
import getEnv from 'src/getEnv'

const BugsnagClient = Bugsnag.start({
  apiKey: getEnv('BUGSNAG_API_KEY'),
  enabledReleaseStages: ['staging', 'production'],
  releaseStage: getEnv('NODE_ENV'),
  plugins: [new BugsnagPluginVue()],
  enabledErrorTypes: {
    unhandledExceptions: true,
    unhandledRejections: false
  },
  onError: function (event) {
    event.setUser(null, LocalStorage?.getItem('user')?.email, null)
    event.addMetadata('connection', {
      effectiveType: navigator?.connection?.effectiveType,
      downlink: navigator?.connection?.downlink,
      rtt: navigator?.connection?.rtt,
      saveData: navigator?.connection?.saveData
    })
  }
})

Vue.use(BugsnagClient)
Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

Vue.prototype.$bugsnag = BugsnagClient

export { BugsnagClient }
